import { createReducer } from 'typesafe-actions'
import { Reducer } from 'redux'
import { FooterState, FooterAction, FooterActionTypes } from './types'

export const initialState: FooterState = {
  patientSupportPhone: '',
  technicalSupportPhone: ''
}

export const footerReducer: Reducer<FooterState> = createReducer<
FooterState,
FooterAction
>(initialState, {
  [FooterActionTypes.FETCH_PHONES_SUCCESS]: (
    state: FooterState,
    action: FooterAction
  ) => ({
    //@ts-ignore
    ...action.payload.data
  })
})
